import { __makeTemplateObject } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { keyframes } from '@emotion/react';

var pulseAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    background-color: ", "\n  }\n  50% {\n    background-color: ", "\n  }\n  100% {\n    background-color: ", "\n  }\n"], ["\n  0% {\n    background-color: ", "\n  }\n  50% {\n    background-color: ", "\n  }\n  100% {\n    background-color: ", "\n  }\n"])), tokens.color.airJordan[100], tokens.color.airJordan[200], tokens.color.airJordan[100]);
styled.div({
    width: "300px",
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[4],
});
var FormHint = styled.p(function (_a) {
    var error = _a.error;
    return ({
        fontFamily: tokens.fontFamilies.primary,
        color: error ? tokens.color.roshe[600] : tokens.color.foamRunner[500],
        fontSize: tokens.fontSize[1],
        minWidth: "100%",
        margin: 0,
        lineHeight: 1.5,
    });
});
var FormLabel = styled.label(function (_a) {
    var error = _a.error, noMargin = _a.noMargin;
    return {
        fontSize: tokens.fontSize[1],
        color: error ? tokens.color.roshe[600] : "initial",
        minWidth: "100%",
        margin: "0 0 ".concat(noMargin ? 0 : tokens.spacing[2]),
        fontFamily: tokens.fontFamilies.primary,
        lineHeight: 1.5,
    };
});
var LoadingInput = styled.div({
    display: "flex",
    height: "56px",
    background: tokens.color.airJordan[100],
    borderRadius: tokens.borderRadius.m,
    animation: "".concat(pulseAnimation, " 1.5s infinite"),
});
var templateObject_1;

export { FormHint, FormLabel, LoadingInput };
//# sourceMappingURL=Form.styles.js.map
